import React from 'react';

function CloseIconMinus() {
  return (
    <svg
      fill="#FFFFFF"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      role="img"
    >
      <title>Remove Class</title>
      <path d="M0 10h24v4h-24z" />
    </svg>
  );
}

export default CloseIconMinus;
